import React from 'react'
import styles from './A23PlayerLastAction.module.css';
import { CALL_ACTION, FOLD_ACTION, RAISE_ACTION, CHECK_ACTION } from '@/Poker/data/Constants';
import { FaCheck, FaTimes, FaChevronUp } from 'react-icons/fa';
import { GAME_STAGE_SHOWDOWN } from '@/Poker/data/Constants';
import { AnimatePresence, motion } from 'motion/react';

export default function A23PlayerLastAction({ lastAction, gameStage, activePlayer, isSeatedOut }) {

    const returnClassNameBasedOnLastAction = () => {
        if (isSeatedOut) {
            return styles.sitOut;
        }
        if (lastAction === CHECK_ACTION) {
            return styles.check;
        }
        if (lastAction === CALL_ACTION) {
            return styles.call;
        }
        if (lastAction === RAISE_ACTION) {
            return styles.raise;
        }
        if (lastAction === FOLD_ACTION) {
            return styles.fold;
        }
    }

    // const returnIconBasedOnLastAction = () => {
    //     if (lastAction === CHECK_ACTION || lastAction === CALL_ACTION) {
    //         return <FaCheck />;
    //     }
    //     if (lastAction === RAISE_ACTION) {
    //         return <FaChevronUp />;
    //     }
    //     if (lastAction === FOLD_ACTION) {
    //         return <FaTimes />;
    //     }
    // }

    const returnInitialValues = () => {
        return {
            // translateX: '-50%',
            translateY: '-100%',
            scale: 0,
        }
    }

    const returnAnimateValues = () => {
        return {
            // translateX: '-50%',
            translateY: '-100%',
            scale: 1,
        }
    }

    if (isSeatedOut) {
        return <AnimatePresence>
            <motion.div
                initial={returnInitialValues()}
                animate={returnAnimateValues()}
                exit={returnInitialValues()}
                className={`${styles.playerLastActionContainer} ${returnClassNameBasedOnLastAction()}`}>
                <div className={styles.playerLastActionText}>
                    SIT OUT
                </div>
            </motion.div>
        </AnimatePresence>
    }

    if (lastAction === FOLD_ACTION) {
        return <AnimatePresence>
            <motion.div
                initial={returnInitialValues()}
                animate={returnAnimateValues()}
                exit={returnInitialValues()}
                className={`${styles.playerLastActionContainer} ${returnClassNameBasedOnLastAction()}`}>
                <div className={styles.playerLastActionText}>
                    Fold
                </div>
            </motion.div>
        </AnimatePresence>
    }

    return <AnimatePresence>
        {lastAction && !activePlayer && gameStage !== GAME_STAGE_SHOWDOWN && (
            <motion.div
                initial={returnInitialValues()}
                animate={returnAnimateValues()}
                exit={returnInitialValues()}
                className={`${styles.playerLastActionContainer} ${returnClassNameBasedOnLastAction()}`}>
                {/* <div className={styles.playerLastActionIcon}>
                {returnIconBasedOnLastAction()}
            </div> */}
                <div className={styles.playerLastActionText}>
                    {lastAction}
                </div>
            </motion.div>
        )}
    </AnimatePresence>
}
